import apiCenterV2 from '../../../services/service_undefined_v2'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      kilo: 0,
      kasob: 0,
      riceKilo: 0,
      isDisabled: false,
      header: ''
    }
  },
  computed: {
    kilos: {
      get: function () {
        if (this.kilo !== '')
          return parseFloat(this.kilo).toFixed(2)
        else
          return parseFloat(0).toFixed(2)
      },
      set: function (newValue) {
        this.kilo = newValue
      }
    },
    kasobs: {
      get: function () {
        if (this.kasob !== '')
          return parseFloat(this.kasob).toFixed(0)
        else
          return parseFloat(0).toFixed(0)
      },
      set: function (newValue) {
        this.kasob = newValue
      }
    }
  },
  methods: {
    NumbersOnly (evt) {
      evt = (evt) ? evt : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    saveSummery () {
      if (!this.isDisabled) {
        let branchName = ''
        const config = JSON.parse(localStorage.getItem('config'))
        if (config.length > 0) {
          branchName = config[0].branch_name.replaceAll(' ', '')
        }
        Swal.fire({
          title: 'การหม่าข้าว',
          text: 'ท่านต้องการยืนยันการหม่าข้าวใช่หรือไม่ ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.value) {
            this.$store.commit('Loading')
            apiCenterV2.saveRiceSummery(
              {
                'kilo': this.kilo,
                'kasob': this.kasob,
                'riceDate': new Date(),
                'summeryRice': (this.kilo * this.riceKilo) + (this.kasob * (this.riceKilo * 45)),
                'branchName': branchName,
                'createdBy': JSON.parse(sessionStorage.user).user_code
              },
              this.header,
              results => {
                if (results.data.isStatus) {
                  $('#ToolModal').modal('hide')
                  this.kasob = 0
                  this.kilo = 0
                  this.$notification['success']({
                    message: 'บันทึกข้อมูลการหม่าข้าว',
                    description: 'บันทึกรายการหม่าข้าวสำเร็จ'
                  })
                } else {
                  this.$notification['warning']({
                    message: 'บันทึกข้อมูลการหม่าข้าว',
                    description: 'บันทึกรายการหม่าข้าวไม่สำเร็จ'
                  })
                }
                this.$store.commit('Loading')
              },
              errors => {
                this.$notification['warning']({
                  message: 'บันทึกข้อมูลการหม่าข้าวไม่สำเร็จ',
                  description: errors.data.message
                })
                this.$store.commit('Loading')
              }
            )
          } else {
            // $('body').on('hidden.bs.modal', '.modal', function () {
            //   $(this).removeData('bs.modal')
            // })
          }
        })
      }
    },
    getSettingRice () {
      // this.$store.commit('Loading')
      apiCenterV2.selectSettingRice(
        this.header,
        results => {
          if (results.data.isStatus && results.data.data.length > 0) {
            this.riceKilo = results.data.data[0].riceKilo
            // if (results.data.data[0].riceKilo == 0) {
            // }
          } else {
            console.log('error')
            this.isDisabled = true
            this.$notification['warning']({
              message: 'ไม่สามารถกำหนดหม่าข้าวได้',
              description: 'เนื่องจากยังไม่ได้กำหนดค่าตั้งต้นที่ MIS'
            })
          }
          // this.$store.commit('Loading')
        },
        errors => {
          console.log(errors)
          this.isDisabled = true
          this.$notification['warning']({
            message: 'ไม่สามารถกำหนดหม่าข้าวได้',
            description: 'เนื่องจากยังไม่ได้กำหนดค่าตั้งต้นที่ MIS'
          })
          // this.$store.commit('Loading')
        }
      )
    },
    closeModal () {
      this.kilo = 0
      this.kasob = 0
    }
  },
  mounted () {
    this.getSettingRice()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/rice_stk.js